import { isObject, isString } from 'lodash';

export const actionTypes = {
  REQUEST_START: 'CONTACTS.APPOINTMENT.MAKE.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.MAKE.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.MAKE.REQUEST_FAILURE',
  RESET: 'CONTACTS.APPOINTMENT.MAKE.RESET',
};

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: searchError(error),
  };
}

function searchError(error) {
  const response = error.response;
  let errorText = error;

  if (response && isObject(response.data)) {
    errorText = response.data.error || '';
  } else if (response && isString(response.data)) {
    errorText = response.data;
  } else if (isString(error.responseText)) {
    errorText = error.responseText;
  } else {
    errorText = 'Ошибка записи на прием';
  }

  return errorText;
}
